import { Outlet } from "react-router";

export function DifferentiationsRoute() {
  return <Outlet />;
}
